"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Pagination from MUI
 * it is easy to create your own version, by using this file as an example
 * see
 * https://material-ui.com/api/pagination/#props
 * https://material-ui.com/api/pagination-item/#props
 * https://material-ui.com/components/pagination/#basic-pagination
 */

var react_1 = __importDefault(require("react"));

var styles_1 = require("@material-ui/core/styles");

var Pagination_1 = __importDefault(require("@material-ui/lab/Pagination"));

var pagination_utils_1 = require("./utils/pagination-utils");

var useStyles = styles_1.makeStyles(function (theme) {
  return styles_1.createStyles({
    root: {
      '& > *': {
        marginTop: theme.spacing(2)
      }
    }
  });
});

var Pagination = function Pagination(props) {
  var n = props.n,
      nPerPage = props.nPerPage,
      idx = props.idx,
      onClick = props.onClick;
  var classes = useStyles();

  if (n === 0) {
    return null;
  }

  var _pagination_utils_1$g = pagination_utils_1.getPagination(n, nPerPage),
      nPage = _pagination_utils_1$g.nPage;

  return react_1.default.createElement("div", {
    className: classes.root
  }, react_1.default.createElement(Pagination_1.default, {
    page: idx,
    onChange: function onChange(_a, b) {
      return onClick(b);
    },
    count: nPage
  }));
};

exports.default = Pagination;